export default {
  pageTitle: 'Complaint Center',
  reportingHistory: 'Reporting History',
  newReport: '+New Report',
  complaintInfo: 'Complaint Info',
  type: 'Type',
  status: 'Status',
  operation: 'Operation',
  viewDetails: 'View Details',
  search: 'Search',
  allTypes: 'All Types',
  allStatus: 'All Status',
  startTime: 'Start Time',
  endTime: 'End Time',
  INFRINGEMENT: 'Infringement',
  PENDING: 'Under Review',
  APPROVED: 'Successful',
  REJECTED: 'Failed',
  productUrl: 'Product URL',
  productUrlPlaceholder: 'Paste product URL',
  reportingType: 'Reporting Type',
  description: 'Reason for Reporting',
  descriptionPlaceholder: 'Please describe the violation in detail',
  uploadCertificate: 'Upload Certificate',
  uploadTip: 'Click to upload certificate (JPG/PNG/PDF)',
  submit: 'Submit',
  reportingRecords: 'Reporting Records',
  complaintId: 'Complaint ID',
  createTime: 'Create Time',
  reportingTypeLabel: 'Reporting Type',
  productUrlLabel: 'Product Url',
  descriptionLabel: 'Reason for Reporting',
  rejectionReasonLabel: 'Reasons for Rejection',
  adminRemarkLabel: 'Remarks',
  INSUFFICIENT_CERTIFICATES: 'Submitted certificates are not sufficient',
  CERTIFICATES_NOT_AUTHENTIC: 'Submitted certificates are not authentic',
  NOT_AUTHENTIC: 'Submitted certificates are not authentic',
  certificateLabel: 'Upload Certificate',
  certificateFile: 'File attachment / Image',
  submitSuccess: 'Report submitted successfully',
  submitFail: 'Failed to submit report',
  fieldRequired: 'This field is required',
  urlInvalid: 'Please enter a valid product URL'
}
